import { useCallback, useEffect, useState } from 'react';
import { Col, Statistic } from 'antd';
import styled from 'styled-components';

// services
import * as DashboardService from '../../../../services/bb-api/dashboards';

export function GroupsActivities(props: any): JSX.Element {
	const setShowError = props.setShowError;
	const [activityData, setActivityData] = useState<Record<string, any>>({});
	const [loading, setLoading] = useState<boolean>(true)


	const getGroupActivities: () => Promise<void> = useCallback(async () => {
		try {
			const groupActivities: Record<string, any> = await DashboardService.queryGroupsActivity();
			setActivityData(groupActivities);
		} catch (error) {
			setShowError(true)
		}

		setLoading(false)
	}, [setShowError]);

	// initialQuery is run on first render of page
	useEffect(() => {
		getGroupActivities();
	}, [getGroupActivities]);

	// useEffect to run initialQuery method once every minute and will also unmount
	useEffect(() => {
		const interval: NodeJS.Timeout = setInterval(async () => {
			await getGroupActivities();
		}, 60_000);

		return () => clearInterval(interval);
	}, [getGroupActivities]);

	return (
		<Container className="panel-container group-activities-panel">
			<h2>Grupper</h2>
			<div className="panel-data">
				<div>
					<Col span={8}>
						<Statistic title="Grupper med aktivitet" value={activityData?.activeGroups} loading={loading}/>
					</Col>
					<Col span={8}>
						<Statistic title="Opslag" value={activityData?.parents} loading={loading}/>
					</Col>
					<Col span={8}>
						<Statistic title="Kommentarer" value={activityData?.children} loading={loading}/>
					</Col>
				</div>
				<div>
					<Col span={8}>
						<Statistic title="" value={' '} loading={loading}/>
					</Col>
					<Col span={8}>
						<Statistic title="Likes" value={activityData?.parentsLike} loading={loading}/>
					</Col>
					<Col span={8}>
						<Statistic title="Likes" value={activityData?.childrenLike} loading={loading}/>
					</Col>
				</div>
			</div>
		</Container>
	);
}

const Container = styled.div`
	.panel-data > div {
		display: flex;
		flex-direction: row;
		text-align: center;

		& > div {
			border-right: 1px solid #9ca3af;

			&:last-child {
				border: none;
			}
		}
	}

	.ant-statistic-title {
		color: #9ca3af;
		font-size: 1.3em;
		margin-bottom: 0px;
	}

	.ant-statistic-content {
		color: #ffffff;
	}
`;
